import { tShared, tSharedWith } from "@/shared/i18n/tShared";
import type { ThreadChannel, ThreadEvent } from "./types";

/**
 * Тексты ленты: ключи shared.supportThread.* (сид supportInbox.ts на
 * бэкенде), русский defaultValue совпадает с сидом и виден в админке.
 * Ключи только литералами, выбор по enum через явные мапы.
 */
export const threadTexts = {
  assistantTitle: () =>
    tShared("shared.supportThread.assistantTitle", "Диалог с помощником"),
  showAll: (count: number) =>
    tSharedWith(
      "shared.supportThread.showAll",
      "Показать весь диалог (сообщений: {{count}})",
      { count }
    ),
  viewer: () => tShared("shared.supportThread.viewer", "Зритель"),
  assistant: () => tShared("shared.supportThread.assistant", "Помощник"),
  createdRequest: () =>
    tShared("shared.supportThread.createdRequest", "Помощник создал обращение"),
  requestText: () =>
    tShared("shared.supportThread.requestText", "Текст обращения"),
  payment: () => tShared("shared.supportThread.payment", "Платёж"),
  details: () =>
    tShared("shared.supportThread.details", "Детали для поддержки"),
  noDialog: () =>
    tShared("shared.supportThread.noDialog", "Диалога с помощником нет"),
  emptyThread: () =>
    tShared(
      "shared.supportThread.emptyThread",
      "Ответов пока нет. Напишите зрителю первым."
    ),
  team: () => tShared("shared.supportThread.team", "Команда"),
  viaAssistant: () =>
    tShared("shared.supportThread.viaAssistant", "через помощника"),
  internalNote: () =>
    tShared("shared.supportThread.internalNote", "Внутренняя заметка"),
  attachmentsSkipped: (count: number) =>
    tSharedWith(
      "shared.supportThread.attachmentsSkipped",
      "Не сохранено вложений: {{count}}",
      { count }
    ),
  showOriginal: () =>
    tShared("shared.supportThread.showOriginal", "Исходное письмо"),
  originalUnavailable: () =>
    tShared(
      "shared.supportThread.originalUnavailable",
      "Исходное письмо недоступно"
    ),
  placeholder: () =>
    tShared("shared.supportThread.composer.placeholder", "Ответ зрителю"),
  notePlaceholder: () =>
    tShared(
      "shared.supportThread.composer.notePlaceholder",
      "Заметка для команды, зритель её не увидит"
    ),
  send: () => tShared("shared.supportThread.composer.send", "Отправить"),
  addNote: () =>
    tShared("shared.supportThread.composer.addNote", "Добавить заметку"),
  resolve: () =>
    tShared("shared.supportThread.composer.resolve", "и решить обращение"),
  internalSwitch: () =>
    tShared("shared.supportThread.composer.internal", "Внутренняя заметка"),
  hotkey: () =>
    tShared("shared.supportThread.composer.hotkey", "Ctrl+Enter отправляет"),
  requestTitle: () =>
    tShared("shared.supportThread.requestTitle", "Обращение зрителя"),
  threadTitle: () => tShared("shared.supportThread.threadTitle", "Переписка"),
  foreignSenderTitle: () =>
    tShared(
      "shared.supportThread.foreignSenderTitle",
      "Письмо с другого адреса"
    ),
  modeLabel: () =>
    tShared("shared.supportThread.composer.modeLabel", "Кому сообщение"),
  modeReply: () =>
    tShared("shared.supportThread.composer.modeReply", "Ответ зрителю"),
  replyHint: () =>
    tShared(
      "shared.supportThread.composer.replyHint",
      "Зритель получит ответ на почту и увидит его на витрине"
    ),
  noteHint: () =>
    tShared(
      "shared.supportThread.composer.noteHint",
      "Заметку видит только команда, зритель её не получит"
    ),
};

/** Подсказка у иконки канала: откуда пришло сообщение. */
export const CHANNEL_HINT: Record<ThreadChannel, () => string> = {
  EMAIL: () => tShared("shared.supportThread.channelHint.EMAIL", "По почте"),
  SITE: () => tShared("shared.supportThread.channelHint.SITE", "На витрине"),
  CABINET: () =>
    tShared("shared.supportThread.channelHint.CABINET", "Из кабинета"),
  SYSTEM: () => tShared("shared.supportThread.channelHint.SYSTEM", "Система"),
};

export const EVENT_TEXT: Record<
  ThreadEvent,
  (v: { name: string; email: string }) => string
> = {
  ASSIGNED: (v) =>
    tSharedWith(
      "shared.supportThread.event.ASSIGNED",
      "Назначено: {{name}}",
      v
    ),
  UNASSIGNED: () =>
    tShared("shared.supportThread.event.UNASSIGNED", "Ответственный снят"),
  RESOLVED: () => tShared("shared.supportThread.event.RESOLVED", "Решено"),
  REOPENED: () =>
    tShared("shared.supportThread.event.REOPENED", "Открыто снова"),
  AUTO_CLOSED: () =>
    tShared(
      "shared.supportThread.event.AUTO_CLOSED",
      "Закрыто автоматически: зритель не ответил"
    ),
  FOREIGN_SENDER: (v) =>
    tSharedWith(
      "shared.supportThread.event.FOREIGN_SENDER",
      "Письмо с другого адреса: {{email}}",
      v
    ),
  REOPEN_BLOCKED: () =>
    tShared(
      "shared.supportThread.event.REOPEN_BLOCKED",
      "Зритель написал в решённое обращение, но по этому платежу уже есть другое активное"
    ),
};
